import React from 'react'
import { Route } from 'react-router-dom'
import { subscribe } from 'react-contextual'
import { Helmet } from 'react-helmet'
import { SettingsProvider, SearchFilterProvider } from '../../../providers'
import { SettingsPageProfile, SettingsBusinessDetails, SettingsCustomise } from '../../../containers'
import { Header, UsersPage, PrivateRoute } from '../..'
import ContentContainer from './ContentContainer/ContentContainer'
import { SegmentsRoute } from '../../../../modules/bookSegments'
import { $TSFixMe } from 'types/ts-migrate'
import SettingIcon from 'components/atoms/Icons/Controls/Settings'

// Route content components are defined at module scope so their identity is
// stable across renders. Passing an inline function to a Route's `component`
// prop makes React Router remount the whole subtree on every parent render.
// React Router injects the route props (match, location, history), so
// components that need `location` receive it here rather than via a closure.
const ProfileRoute = () => (
  <ContentContainer>
    <Header icon={<SettingIcon />} tag="h1" text="Profile" />
    <SettingsPageProfile />
  </ContentContainer>
)

const BusinessDetailsRoute = () => (
  <ContentContainer>
    <Header icon={<SettingIcon />} tag="h1" text="Business Details" />
    <SettingsBusinessDetails />
  </ContentContainer>
)

const BrandingRoute = () => (
  <ContentContainer>
    <SettingsCustomise />
  </ContentContainer>
)

const UsersRoute = ({ location }: $TSFixMe) => (
  <SearchFilterProvider location={location}>
    <UsersPage />
  </SearchFilterProvider>
)

interface IContentRoutesProps {
  url: string
  userRole: string
}

const ContentRoutes = ({ url, userRole }: IContentRoutesProps) => {
  const isAuthorised = userRole === 'Owner' || userRole === null

  return (
    <>
      <Helmet>
        <title>reOS | Settings</title>
      </Helmet>
      <Route path={`${url}/profile`} component={ProfileRoute} />
      <PrivateRoute path={`${url}/business-details`} isAuthorised={isAuthorised} component={BusinessDetailsRoute} />
      <PrivateRoute path={`${url}/branding`} isAuthorised={isAuthorised} component={BrandingRoute} />
      <PrivateRoute path={`${url}/users`} isAuthorised={isAuthorised} component={UsersRoute} />
      <PrivateRoute path={`${url}/segments`} isAuthorised={isAuthorised} component={SegmentsRoute} />
    </>
  )
}

interface ISettingsPageProps {
  url?: string
  match?: $TSFixMe
  location?: $TSFixMe
  userRole: string
}

const SettingsPage = ({ match, userRole }: ISettingsPageProps): React.ReactElement => (
  <ContentRoutes url={match.url} userRole={userRole} />
)

export default subscribe(SettingsProvider, ({ match, location, userRole }) => ({
  match,
  location,
  userRole,
}))(SettingsPage)
